export default "__VITE_ASSET__62400825__"